// eslint-disable-next-line import/prefer-default-export
export const UNKNOW_ERROR = 'Some error occurred. Please try again later.';
export const NO_INTERNET = 'No Internet';
export const CONNECTION_FAILED = 'Connection with the server failed';

export const API_RESPONSE_CODE = {
    SUCCESS: 0,
    ERROR: 1,   
    FAILURE: 2, 
}
